import { Helmet } from 'react-helmet';
import { Divider, Form } from 'antd';
import { useIntl } from 'react-intl';
import { PageProps } from '@/types/PageProps';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import DeliveryOfMaterialForm from '@/components/Reports/StockReports/DeliveryOfmaterialForm';
import useCommonGenerateNetReport from '@/core/domain/NetReport/commons/Report.hook';
import {
  DeliveryOfMaterialDateType,
  DeliveryOfMaterialFormValues,
} from '@/core/domain/reports/stock/DeliveryOfmaterial/DeliveryOfmaterial.types';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { useReportHandlers } from '@/hooks/useReportHandler';
import moment from 'moment';

const StockDeliveryOfMaterialsPage = ({ route }: PageProps) => {
  const [form] = Form.useForm<
    DeliveryOfMaterialFormValues & ReportDateInterface
  >();
  const { mutateAsync } = useCommonGenerateNetReport<
    DeliveryOfMaterialFormValues & DeliveryOfMaterialDateType
  >(
    '/Reports/MaterialDeliveryReturn',
    'Relatório de Entrega de Materiais',
    'Relatóri de Entrega de Materiais gerado com sucesso!',
    false,
    true,
  );
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    try {
      setFileLoading(format);
      const values = await form.validateFields();

      const obj: DeliveryOfMaterialFormValues & DeliveryOfMaterialDateType = {
        ...values,
        startDate: moment(values.initialDate).format('YYYY-MM-DD'),
        endDate: moment(values.finalDate).format('YYYY-MM-DD'),
        companiesIds: values.companiesIds?.toString(),
        employeesIds: values.employeesIds?.toString().replace(' ', ','),
        showEmployee: values.showEmployee || false,
      };

      const result = await mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}
    setFileUnloading(format);
  };

  const { handleView, handlePdf } = useReportHandlers(
    'Relatório de Entrega de Materiais',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />
      <DeliveryOfMaterialForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        loading={fileLoading}
        viewReport={handleView}
        generatePdf={handlePdf}
      />
    </DefaultRouteTabs>
  );
};

export default StockDeliveryOfMaterialsPage;
